import { AppConstants } from './../../../shared/constants/constants';
import { AppMessages } from './../../../shared/constants/messages';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgForm, FormControl, FormBuilder, FormGroup, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { Utility } from '../../../common/utility';
import { ValidationService } from '../../../shared/services/validation.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { ManagePatientAccountService } from './manage-patient.service';
import { UserUrl } from '../../../shared/urls/user.url';
import { PatientModel } from '../../../models/consultation/patient.model';
import { UserType } from '../../../shared/constants/permission';
import { environment } from '../../../../environments/environment';
@Component({
    selector: 'patient-information-form',
    templateUrl: 'patient-information-form.component.html',
    providers: [ManagePatientAccountService]
})

export class PatientInformationFormComponent implements OnInit {
    @ViewChild('formDir') ngForm;
    @ViewChild('patient') patient;
    public patientInformationForm: FormGroup;
    public patientModel = new PatientModel();
    public klass = 'patientinformation';
    public msgPatients = '';

    public isSeparate = false;
    public isAdd = false; // use in add patient form
    public isEdit = false;
    public isHidden = false;
    public titleData = [];
    public countryData = [];
    public collegeData = [];
    public partyData = [];
    public partyTypes = [];
    public patients: any;
    public partyTypeEnum = {
        Individual: -1,
        Group: -1,
        Family: -1
    };
    public occupationData: any;
    public healthinsuranceData: any;
    public marketingData: any;
    public sexs = [];
    public occupationStudent: any;

    constructor(public formBuilder: FormBuilder,
        public utility: Utility,
        private dialogService: DialogService,
        public managePatientAccountService: ManagePatientAccountService
    ) {
        this.createForm();
    }

    ngOnInit() {

        this.managePatientAccountService.getInIt().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.collegeData = data['colleges'];
                    this.healthinsuranceData = data['healthInsurances'];
                    this.occupationData = data['occupations'];
                    // this.partyTypes = data['partyTypes'];
                    this.titleData = data['titles'];
                    this.marketingData = data['marketings'];
                    // if occupation == student then show Collage and StudentId
                    const studentId = this.occupationData.find(o => o.name === 'Student') || {};
                    this.occupationStudent = studentId['id'];
               }
            }
        );

        if (!this.isEdit) {
            this.patientModel.patientREF = 'N/A';
            this.patientInformationForm.controls['isCreateMyTMBAccount'].setValue(false);
            if (this.patientInformationForm.controls['isCreateMyTMBAccount'].value === true
                 || (this.patientModel != null && this.patientModel.isCreateMyTMBAccount === true))
            {
                ValidationService.attachRequired(this.patientInformationForm.controls['email'], [Validators.required, ValidationService.isValidEmail]);
            } else
            {
                ValidationService.removeRequired(this.patientInformationForm.controls['email'], [ValidationService.isValidEmail]);
            }
        }

        this.managePatientAccountService.getCountryData().subscribe(
            (result) => {
                if (result) {
                    const data = result.json();
                    this.countryData = data;
                    // By default select Ireland
                    const defaultCountryId = this.countryData.find(c => c.name.toUpperCase() === 'IRELAND');
                    // localStorage.getItem(AppConstants.localStorage.countryId);
                    if (!this.patientModel.countryId) {
                        this.patientInformationForm.controls['countryId'].setValue(defaultCountryId['id']);
                        this.patientInformationForm.controls['countryOfBirthId'].setValue(defaultCountryId['id']);
                    }
                }
            }
        );

        this.managePatientAccountService.getParty().subscribe(
            (result) => {
                if (result) {
                    this.partyData = result.json();
                }
            }
        );

        const dateOfBirth = this.utility.convertDateToString(this.patientInformationForm.controls['birthDay'].value);
        this.patientInformationForm.controls['dateOfBirth'].setValue(dateOfBirth);
        this.managePatientAccountService.getTypeParty().subscribe(result => {
            if (result) {
                this.partyTypes = result.json();
                this.partyTypes.forEach(type => {
                    if (this.partyTypeEnum[type.name]) {
                        this.partyTypeEnum[type.name] = type.id;
                    }
                });
            }
        });
        this.sexs = this.managePatientAccountService.getSexData();
        this.partyTypeChange();
        this.createMyTMBAccountChange();
    }

    createForm() {
        this.patientInformationForm = this.formBuilder.group({
            userName: [''],
            patientREF: [''],
            titleId: ['', [Validators.required]],
            firstName: ['', [Validators.required]],
            middleName: [''],
            surName: ['', [Validators.required]],
            sexId: ['', [Validators.required]],
            birthDay: [null, [Validators.required, ValidationService.isValidDateOfBirth]],
            email: ['', [Validators.required, ValidationService.isValidEmail]],
            address1: ['', [Validators.required]],
            address2: ['', [Validators.required]],
            address3: [''],
            postCode: [''],
            countryId: ['', [Validators.required]],
            homePhone: [''],
            workPhone: [''],
            mobilePhone: [''],
            countryOfBirthId: ['', [Validators.required]],
            occupationId: ['', [Validators.required]],
            partyTypeId: ['', [Validators.required]],
            partyId: [''],
            college: [''],
            studentId: [''],
            healthInsuranceId: [''],
            healthPolicyNumber: [''],
            policyNumber: [''],
            marketingId: [''],
            isCreateMyTMBAccount: [false],
            sendActivationEmail: [false],
            isEnableCreateMyTMBAccount: [false],
            isIncludeInMarketing: [false],
            isSeparateBillingAddress: [false],
            isDeceased: [false],
            isActive: [false],
            isDisable: [false],
            billingAddress1: [''],
            billingAddress2: [''],
            billingAddress3: [''],
            billingPostCode: [''],
            billingCountryId: [],
            callBackUrl: environment.mytmbServer + UserUrl.GET_APP_ACTIVE_LINK_URL,
            dateOfBirth: [''],
            passportOrIdNumber: [''],
            myTmbPassword:[''],
            isManuallyActive: [false],
        });
    }

    inputMaxLength() {
        return 50;
    }

    onDobChange(dateText) {
        //ValidationService.validationDate(this.patientInformationForm.controls['birthDay'], dateText);
        const dateOfBirth = this.utility.convertDateToString(this.patientInformationForm.controls['birthDay'].value);
        this.patientInformationForm.controls['dateOfBirth'].setValue(dateOfBirth);
    }

    partyTypeChange() {
        if (this.patientModel.partyTypeId === '1') {
            ValidationService.attachRequired(this.patientInformationForm.controls['partyId'], []);
        } else {
            ValidationService.removeRequired(this.patientInformationForm.controls['partyId'], []);
        }
    }

    createMyTMBAccountChange() {
        if (this.patientInformationForm.controls['isCreateMyTMBAccount'].value === true) {
            ValidationService.attachRequired(this.patientInformationForm.controls['email'], [Validators.required, ValidationService.isValidEmail]);
        } else {
            ValidationService.removeRequired(this.patientInformationForm.controls['email'], [ValidationService.isValidEmail]);
        }
        if(this.patientModel != null && this.patientModel.isEnableCreateMyTMBAccount === false){
            //this.patientInformationForm.controls['isCreateMyTMBAccount'].disable();
            ValidationService.attachRequired(this.patientInformationForm.controls['email'], [Validators.required, ValidationService.isValidEmail]);
        }
    }

    addSeparateBillingAddress(e) {
        if (this.patientModel.billingAddress1 === '') {
            this.patientModel.billingAddress1 = this.patientModel.address1;
        }
        if (this.patientModel.billingAddress2 === '') {
            this.patientModel.billingAddress2 = this.patientModel.address2;
        }
        if (this.patientModel.billingAddress3 === '') {
            this.patientModel.billingAddress3 = this.patientModel.address3;
        }

        if (this.patientModel.billingPostCode === '') {
            this.patientModel.billingPostCode = this.patientModel.postCode;
        }

        // BE billingCountryId need to empty
        if (this.patientModel.billingCountryId === null) {
            this.patientModel.billingCountryId = this.patientModel.countryId;
        }
    }

    onChangeDecease(event) {
        if (event.checked) {
            const confirmMessage = AppMessages.patient.checkedDeceased;
            this.dialogService.openConfirmationDialog({ message: confirmMessage }).subscribe(result => {
                if (!result) {
                    this.patientInformationForm.controls['isDeceased'].setValue(!event.checked);
                }
            });
        }
    }

    onChangeDisable(event) {
        const param = {
            email: this.patientModel.email
        };

      if (event.checked) {
        var itemResult:any;
        var messageWarning = '';
        this.managePatientAccountService.getPatientsByEmail(param).subscribe(
            (result) => {
                if (result) {
                    itemResult = result.json();
                    if(itemResult.length > 0)
                    {
                        messageWarning = 'This will affect the following patients: ';
                    }
                    itemResult.forEach(element => {
                        messageWarning += element.patientREF + ' ' + element.firstName + ', ';
                      });
                    const confirmDisablePatient = AppMessages.centre.confirmDisablePatient;
                    if(messageWarning.length >2)
                    {
                    messageWarning= messageWarning.substring(0,messageWarning.length-2) + '. ';
                    }
                    this.dialogService.openConfirmationDialog({ message: messageWarning  + confirmDisablePatient }).subscribe(result => {
                    if (!result) {
                        this.patientInformationForm.controls['isDisable'].setValue(!event.checked);
                        }
                    });
                }
            }
        );
      }
      else if (!event.checked){
        this.managePatientAccountService.getPatientsByEmail(param).subscribe(
            (result) => {
                if (result) {
                    itemResult = result.json();
                    if(itemResult.length > 0)
                    {
                        messageWarning = 'This will affect the following patients:';
                    }
                    itemResult.forEach(element => {
                        messageWarning += element.patientREF + ' ' + element.firstName +', ';
                      });
                      if(messageWarning.length >2)
                    {
                    messageWarning= messageWarning.substring(0,messageWarning.length-2) + '. ';
                    }
                    const confirmEnablePatient = AppMessages.centre.confirmEnablePatient;
                    this.dialogService.openConfirmationDialog({ message: messageWarning +  confirmEnablePatient }).subscribe(result => {
                        if (result) {
                            this.patientInformationForm.controls['isDisable'].setValue(event.checked);
                        }
                    });
                    }
                })
            }
    }

  onChangeManuallyActive(event) {
    if (event.checked && !this.patientModel.isCreateMyTMBAccount) {
      this.patientModel.isCreateMyTMBAccount = true;
    }
  }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/patient-information-form.component.ts